module.exports = __webpack_public_path__ + "img/daily_mail.7c828587.svg";